module.exports = __webpack_public_path__ + "static/media/react.201e7f7f.png";